<template>
  <div>
    <!-- 经营情况 -->
    <filter-search
      :isShowDateTab="true"
      exportTemplate="BoardOperation"
      filename='运营情况'
      @dateChange="dateChange"
      @dateTabChange="dateTabChange"
      @search="search"
    />
    <!-- 维度 -->
    <dimension-table :dateText="dateText" :tableData="tableDataList.allOperateVOS" />
    <!-- 个人 -->
    <person-table
      :dateText="dateText"
      :dateStr="dateStr"
      :tableData="tableDataList.personalOperateVOS"
    />
    <!-- 企业 -->
    <enterprise-table
      :dateText="dateText"
      :dateStr="dateStr"
      :tableData="tableDataList.entOperateVOS"
    />
  </div>
</template>
<script>
import filterSearch from '../FilterSearch.vue'
import dimensionTable from './dimensionTable/index.vue'
import personTable from './personTable/index.vue'
import enterpriseTable from './enterpriseTable/index.vue'
import { postStatOperation } from '@/api/domain/workbench'
import moment from 'moment'

export default {
  components: {
    dimensionTable,
    personTable,
    enterpriseTable,
    filterSearch,
  },
  data() {
    return {
      formData: {
        searchDate: moment().format('YYYY-MM-DD') || '',
        startDate: '',
        endDate: '',
        searchType: 1,
      },
      dateStr: '', // 周、月 转化的时间戳
      tableDataList: {
        allOperateVOS: [],
        personalOperateVOS: [],
        entOperateVOS: [],
      },
      dateText: '',
    }
  },
  methods: {
    // 搜索按钮
    search(val, cb) {
      this.formData = val
      this.setDateText(val)
      this.postStatOperation().then(() => {
        cb()
      })
    },
    setDateText(val) {
      const { startDate, endDate } = val
      if (startDate && endDate) {
        this.dateText = `${startDate.replace(/-/g, '/')} - ${endDate.replace(/-/g, '/')}`
      } else {
        this.dateText = ''
      }
    },
    // 请求数据
    async postStatOperation() {
      const params = {
        searchType: this.formData.searchType,
        startDate: this.formData.startDate,
        endDate: this.formData.endDate,
        searchDate: this.formData.searchDate,
      }
      const { data } = await postStatOperation(params)
      this.tableDataList.allOperateVOS = data?.allOperateVOS || []
      this.tableDataList.personalOperateVOS = data?.personalOperateVOS || []
      this.tableDataList.entOperateVOS = data?.entOperateVOS || []
      return data
    },
    // 选择
    dateChange(data, dateStr) {
      this.formData = data
      this.dateStr = dateStr
    },
    // 日 周 月 tab切换
    dateTabChange(formData) {
      this.formData = formData
    },
  },
}
</script>
